import O1HD from "../../../../engines/gameEngine";
import {DriftBattleEntity, DriftChooseEntity} from "./config/DriftBattleConfig";
import getOneBundle, {BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

/**
 * 湖里面漂流瓶
 */
@ccclass
export default class LakeDriftBattleNode extends cc.Component {

    @property({type:cc.Node,displayName:"选项1"})
    choose1Btn : cc.Node = null;
    @property({type:cc.Node,displayName:"选项2"})
    choose2Btn : cc.Node = null;

    @property(cc.Node)
    contentNode : cc.Node = null;
    @property({type:cc.Sprite,displayName:"图片"})
    imgNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"标题"})
    lbTitle : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    lbDesc : cc.Label = null;
    @property({type:cc.Label,displayName:"署名"})
    lbSignature : cc.Label = null;


    @property(cc.Node)
    contentNormalNode : cc.Node = null;
    @property(cc.Sprite)
    normalHeadImgNode : cc.Sprite = null;
    @property(cc.Sprite)
    normalImgNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"标题"})
    lbNormalTitle : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    lbNormalDesc : cc.Label = null;
    @property({type:cc.Label,displayName:"署名"})
    lbNormalSignature : cc.Label = null;

    @property(cc.Node)
    contentLotteryNode : cc.Node = null;
    @property(cc.Sprite)
    lotteryHeadImgNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"署名"})
    lbLotterySignature : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    lbLotteryDesc : cc.Label = null;
    @property(cc.Label)
    lbLotteryNumNode : cc.Label[] = [];
    @property(cc.Node)
    doubleGetBtn : cc.Node = null;

    @property( cc.Node )
    contentGoodsNode : cc.Node = null;
    @property({type:cc.Sprite,displayName:"图片"})
    goodsImgNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"名称"})
    lbGoodsName : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    lbGoodsDesc : cc.Label = null;


    @property( cc.Node )
    contentSpecialNode : cc.Node = null;
    @property({type:cc.Label,displayName:"标题"})
    lbSpecialTitle : cc.Label = null;
    @property({type:cc.Label,displayName:"描述"})
    lbSpecialDesc : cc.Label = null;

    private mDriftBattleEntity : DriftBattleEntity;
    randomLotteryNumArray : number[] = null;
    randomGoldLotteryArray : number[] = null;

    onLoad () {}

    start () {

    }

    /**
     * 绑定数据
     */
    async bindData( driftBattleEntity : DriftBattleEntity ){
        this.mDriftBattleEntity = driftBattleEntity;
        console.log("this.mDriftBattleEntity" , this.mDriftBattleEntity );
        if ( this.mDriftBattleEntity.type == 1 ) {
            //最基础的弹窗
            this.contentNode.active = true;
            //标题
            if ( this.mDriftBattleEntity.title ) {
                this.lbTitle.node.active = true;
                this.lbTitle.string = `${this.mDriftBattleEntity.title}`;
            }
            //加载图片
            if ( this.mDriftBattleEntity.imgPath ) {
                this.imgNode.node.active = true;
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                bundle.load( `backpackAssets/objSp/${this.mDriftBattleEntity.imgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.log(`图片路径`,this.mDriftBattleEntity.imgPath );
                        return;
                    }
                    this.imgNode.spriteFrame = assets;
                });
            }
            //署名
            if ( this.mDriftBattleEntity.signature ) {
                this.lbSignature.node.active = true;
                this.lbSignature.string = `${this.mDriftBattleEntity.signature}`;
            }
            //内容
            this.lbDesc.string = `${this.mDriftBattleEntity.desc}`;
        }else if ( this.mDriftBattleEntity.type == 2 ){
            // NPC 头像告知
            this.contentNormalNode.active = true;
            if ( this.mDriftBattleEntity.title ) {
                this.lbNormalTitle.node.active = true;
                this.lbNormalTitle.string = `${this.mDriftBattleEntity.title}`;
            }
            //加载图片
            if ( this.mDriftBattleEntity.imgPath ) {
                this.normalImgNode.node.active = true;
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                bundle.load( `backpackAssets/objSp/${this.mDriftBattleEntity.imgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.log(`图片路径`,this.mDriftBattleEntity.imgPath );
                        return;
                    }
                    this.normalImgNode.spriteFrame = assets;
                });
            }
            //加载头像
            if ( this.mDriftBattleEntity.headImgPath ) {
                this.normalHeadImgNode.node.active = true;
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.WeChatGameBundle );
                bundle.load( `weChatSprite/${this.mDriftBattleEntity.headImgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.log(`图片路径`,this.mDriftBattleEntity.headImgPath );
                        return;
                    }
                    this.normalHeadImgNode.spriteFrame = assets;
                });
            }
            //署名
            if ( this.mDriftBattleEntity.signature ) {
                this.lbNormalSignature.node.active = true;
                this.lbNormalSignature.string = `${this.mDriftBattleEntity.signature}`;
            }
            //内容
            this.lbNormalDesc.string = `${this.mDriftBattleEntity.desc}`;
        }else if ( this.mDriftBattleEntity.type == 3 ) {
            this.contentLotteryNode.active = true;
            //加载头像
            if ( this.mDriftBattleEntity.headImgPath ) {
                this.lotteryHeadImgNode.node.active = true;
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.WeChatGameBundle );
                bundle.load( `weChatSprite/${ this.mDriftBattleEntity.headImgPath }` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.log(`图片路径`,this.mDriftBattleEntity.headImgPath );
                        return;
                    }
                    this.lotteryHeadImgNode.spriteFrame = assets;
                });
            }
            //署名
            if ( this.mDriftBattleEntity.signature ) {
                this.lbLotterySignature.node.active = true;
                this.lbLotterySignature.string = `${this.mDriftBattleEntity.signature}`;
            }
            //内容
            this.lbLotteryDesc.string = `${this.mDriftBattleEntity.desc}`;
            // 生成随机 中奖号码
            let tempArray : number[] = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24];
            this.randomLotteryNumArray = this._getRandomLotteryNum( tempArray , 5 );

            let randomGoldCount : number = Math.floor( Math.random() * 6 );
            this.randomGoldLotteryArray = this._getRandomLotteryNum( this.randomLotteryNumArray.concat([]), randomGoldCount );
            //设置号码
            for ( let i = 0 ; i < this.randomLotteryNumArray.length ; i ++ ) {
                this.lbLotteryNumNode[i].string = `${this.randomLotteryNumArray[i]}`;
            }
        }else if ( this.mDriftBattleEntity.type == 5 ) {
            //物品
            this.contentGoodsNode.active = true;
            O1HD.getManagers().soundMgr.playSound("openTreasure").then();
            //加载头像
            if ( this.mDriftBattleEntity.imgPath ) {
                this.goodsImgNode.node.active = true;
                let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                bundle.load( `backpackAssets/objSp/${this.mDriftBattleEntity.imgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.error(`图片路径`,this.mDriftBattleEntity.imgPath );
                        return;
                    }
                    this.goodsImgNode.spriteFrame = assets;
                });
            }
            if ( this.mDriftBattleEntity.title ) {
                this.lbGoodsName.node.active = true;
                this.lbGoodsName.string = `${this.mDriftBattleEntity.title}`;
            }
            //内容
            this.lbGoodsDesc.string = `${this.mDriftBattleEntity.desc}`;
        }else if ( this.mDriftBattleEntity.type == 6 ){
            //特殊事件告知
            this.contentSpecialNode.active = true;
            //标题
            if ( this.mDriftBattleEntity.title ) {
                this.lbSpecialTitle.node.active = true;
                this.lbSpecialTitle.string = `${this.mDriftBattleEntity.title}`;
            }
            //内容
            this.lbSpecialDesc.string = `${this.mDriftBattleEntity.desc}`;
        }

        //选项1
        this.choose1Btn.getChildByName("Background").getChildByName("Label")
            .getComponent(cc.Label).string = `${this.mDriftBattleEntity.chooseArray[0].chooseStr}`;
        //选项2
        if ( this.mDriftBattleEntity.chooseArray.length > 1 ) {
            this.choose2Btn.active = true;
            this.choose2Btn.getChildByName("Background").getChildByName("Label")
                .getComponent(cc.Label).string = `${this.mDriftBattleEntity.chooseArray[1].chooseStr}`;
        }
        //双倍领取
        if ( this.mDriftBattleEntity.type == 5 ) {
            this.doubleGetBtn.active = true;
        }

    }




    private _getRandomLotteryNum( tempArray :number[], count : number ){
        let retNum : number[] = [];
        for ( let i = 0 ; i < count; i++ ) {
            let randomIndex = Math.floor( Math.random() * tempArray.length );
            retNum = retNum.concat( tempArray.splice( randomIndex , 1 ) );
        }
        return retNum;
    }

    /**
     * 选项
     * @param e
     * @param chooseDefine 1 or 2
     */
    async onBtnChoose( e , chooseDefine ){
        if ( chooseDefine == "goods" ) {
            //物品
            let driftBattleEntity = JSON.stringify( this.mDriftBattleEntity );
            console.log( "driftBattleEntity" , driftBattleEntity );
            utilsModel.loadAndShowVideoAdTrans(
                async ()=>{
                    await NormalGameManager._instance.driftBattleManager.consumerEvent( JSON.parse(driftBattleEntity) , 0 ,this.randomLotteryNumArray,this.randomGoldLotteryArray, e.target , true );
                    this._close();
                    },
                ()=>{
                O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
            },()=>{}
            ,"漂流瓶-双倍获取")
        }else{
            switch ( Number(chooseDefine) ) {
                case 1:
                    await NormalGameManager._instance.driftBattleManager.consumerEvent( this.mDriftBattleEntity , 0 ,this.randomLotteryNumArray,this.randomGoldLotteryArray, e.target );
                    break;
                case 2:
                    await NormalGameManager._instance.driftBattleManager.consumerEvent( this.mDriftBattleEntity , 1 ,this.randomLotteryNumArray,this.randomGoldLotteryArray, e.target );
                    break;
            }
            this._close();
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }


    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
